import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseModalComponent } from '../../../../models/base/base-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseButtonSizeEnum } from '../../components/base-button/base-button-size.enum';
import { BaseButtonColourEnum } from '../../components/base-button/base-button-colour.enum';
import { CloseButtonComponent } from '../../components/close-button/close-button.component';
import { CommonModule } from '@angular/common';
import { SecondaryButtonComponent } from '../../components/secondary-button/secondary-button.component';
import { TertiaryButtonComponent } from '../../components/tertiary-button/tertiary-button.component';
import { PrimaryButtonComponent } from '../../components/primary-button/primary-button.component';
import { ThrottleClickDirective } from '../../directives/throttle-click.directive';

export enum SecondaryButtonStyleEnum {
  Secondary,
  Tertiary
}

@Component({
  selector: 'app-base-action-modal',
  templateUrl: './base-action-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    CloseButtonComponent,
    SecondaryButtonComponent,
    TertiaryButtonComponent,
    PrimaryButtonComponent,
    ThrottleClickDirective
  ],
  styleUrls: ['./base-action-modal.component.scss']
})
export class BaseActionModalComponent extends BaseModalComponent {
  // Ensure title is localized before being passed in
  @Input() modalTitle: string = '';
  // Ensure primaryLabel is localized before being passed in
  @Input() primaryLabel: string = '';
  // Ensure secondaryLabel is localized before being passed in
  @Input() secondaryLabel: string = '';
  @Input() secondaryButtonStyle: SecondaryButtonStyleEnum = SecondaryButtonStyleEnum.Tertiary;

  @Input() hidePrimary: boolean = false;
  @Input() hideSecondary: boolean = false;
  @Input() hideClose: boolean = false;
  // Use in conjunction with ignoreEscapeModalOptions to ensure the modal
  // cannot be closed on escape
  @Input() ignoreEscape: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() primaryDisabled: boolean = false;
  @Input() secondaryDisabled: boolean = false;
  @Input() closeDisabled: boolean = false;

  @Output() closeClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() primaryClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() secondaryClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private activeModal: NgbActiveModal) {
    super(activeModal);
  }

  setupBindings(): void {}

  setupViews(): void {}

  public handleCloseClick(): void {
    if (!this.isLoading && !this.closeDisabled) {
      this.closeClicked.emit();
    }
  }

  protected readonly SecondaryButtonStyleEnum = SecondaryButtonStyleEnum;
  protected readonly BaseButtonSizeEnum = BaseButtonSizeEnum;
  protected readonly BaseButtonColourEnum = BaseButtonColourEnum;
}
